// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAllowedServiceDto } from './IAllowedServiceDto';
import {
    IAllowedServiceDtoFromJSON,
    IAllowedServiceDtoFromJSONTyped,
    IAllowedServiceDtoToJSON,
    IAllowedServiceDtoToJSONTyped,
} from './IAllowedServiceDto';

/**
 * 
 * @export
 * @interface IPayoutDefinitionUpdateDto
 */
export interface IPayoutDefinitionUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionUpdateDto
     */
    name: string;
    /**
     * 
     * @type {Array<IAllowedServiceDto>}
     * @memberof IPayoutDefinitionUpdateDto
     */
    allowed_services?: Array<IAllowedServiceDto>;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionUpdateDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionUpdateDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPayoutDefinitionUpdateDto
     */
    is_limited_use?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionUpdateDto
     */
    mp_table_id: number;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionUpdateDto
     */
    cov_table_id?: number;
}

/**
 * Check if a given object implements the IPayoutDefinitionUpdateDto interface.
 */
export function instanceOfIPayoutDefinitionUpdateDto(value: object): value is IPayoutDefinitionUpdateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mp_table_id' in value) || value['mp_table_id'] === undefined) return false;
    return true;
}

export function IPayoutDefinitionUpdateDtoFromJSON(json: any): IPayoutDefinitionUpdateDto {
    return IPayoutDefinitionUpdateDtoFromJSONTyped(json, false);
}

export function IPayoutDefinitionUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayoutDefinitionUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'allowed_services': json['allowed_services'] == null ? undefined : ((json['allowed_services'] as Array<any>).map(IAllowedServiceDtoFromJSON)),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'is_limited_use': json['is_limited_use'] == null ? undefined : json['is_limited_use'],
        'mp_table_id': json['mp_table_id'],
        'cov_table_id': json['cov_table_id'] == null ? undefined : json['cov_table_id'],
    };
}

export function IPayoutDefinitionUpdateDtoToJSON(json: any): IPayoutDefinitionUpdateDto {
    return IPayoutDefinitionUpdateDtoToJSONTyped(json, false);
}

export function IPayoutDefinitionUpdateDtoToJSONTyped(value?: IPayoutDefinitionUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'allowed_services': value['allowed_services'] == null ? undefined : ((value['allowed_services'] as Array<any>).map(IAllowedServiceDtoToJSON)),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'is_limited_use': value['is_limited_use'],
        'mp_table_id': value['mp_table_id'],
        'cov_table_id': value['cov_table_id'],
    };
}

